import React, { useState, useEffect, useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import AboutLayout from '../../layouts/AboutLayout';
import { House } from 'react-bootstrap-icons';
import { useNavigate, useLocation } from 'react-router-dom';

import ISADgCollectionLoading from './ISADgCollectionLoading';
import ISADgCollectionError from './ISADgCollectionError';
import ISADgCollectionContent from './ISADgCollectionContent/ISADgCollectionContent';

const acervo_data = {
	'GT-CIRMA-FG': {
		title: 'Fototeca Guatemala',
		agency: 'fototeca',
		code: 'GT-CIRMA-FG',
	},
	'GT-CIRMA-AH': {
		title: 'Archivo Histórico',
		agency: 'archivo',
		code: 'GT-CIRMA-AH',
	},
};

export default function ISADgCollection3(props) {
	const { isadg } = useParams();
	const navigate = useNavigate();
	const { apiService } = props;
	const [showMetadata, setShowMetadata] = useState({
		show: isadg.includes('GT-CIRMA-AH'),
		metadata: {},
	});
	const [itemInfo, setItemInfo] = useState({
		isLoading: false,
		payload: {},
	});
	const [searchParams, setSearchParams] = useSearchParams();
	const isadg_nav = searchParams.get('nav');
	const [IsadgMetadata, setIsadgMetadata] = useState({
		isLoading: false,
		payload: {},
		isError: false,
		message: '',
	});
	const location = useLocation();
	const [mySelectedPhotos2, setMySelectedPhotos2] = useState({
		isLoading: false,
		payload: { collections: [] },
	});

	if (!isadg_nav) {
		setSearchParams({ nav: isadg }, { replace: true });
	}

	useEffect(() => {
		try {
			setItemInfo({ isLoading: true, payload: {} });
			apiService.getItem({}, { isadg: isadg_nav }, (_, rdata) => {
				//console.log(rdata);
				setItemInfo({ isLoading: false, payload: rdata });
			});
		} catch (e) {
			//console.log(e);
			setItemInfo({ isLoading: false, payload: {} });
		}
	}, [apiService, isadg_nav]);

	const acervo = useMemo(
		() =>
			acervo_data[
				isadg.includes('GT-CIRMA-FG') ? 'GT-CIRMA-FG' : 'GT-CIRMA-AH'
			],
		[isadg]
	);

	useEffect(() => window.scrollTo(0, 0), []);

	useEffect(() => {
		if (mySelectedPhotos2.isLoading)
			apiService.getCollectionImages(
				{ page: 2 },
				{ isadg: isadg_nav },
				(rstatus, rdata) => {
					for (let fi = 0; fi < rdata.length; fi++) {
						if (isNaN(rdata[fi].width)) {
							rdata[fi].width = 480;
							rdata[fi].height = 360;
						}
					}
					setMySelectedPhotos2({
						isLoading: false,
						loaded: isadg_nav,
						payload: { collections: rdata },
					});
				}
			);
		else {
			if (mySelectedPhotos2.loaded !== isadg_nav) {
				setMySelectedPhotos2({
					isLoading: true,
					loaded: '',
					payload: [],
				});
				apiService.getCollectionImages(
					{ page: 2 },
					{ isadg: isadg_nav },
					(rstatus, rdata) => {
						for (let fi = 0; fi < rdata.length; fi++) {
							if (isNaN(rdata[fi].width)) {
								rdata[fi].width = 480;
								rdata[fi].height = 360;
							}
						}
						//console.log(rdata);
						setMySelectedPhotos2({
							isLoading: false,
							loaded: isadg_nav,
							payload: { collections: rdata },
						});
					}
				);
			}
		}
		return () => {
			setMySelectedPhotos2({
				isLoading: false,
				loaded: '',
				payload: [],
			});
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	useEffect(() => {
		try {
			setIsadgMetadata({
				isLoading: true,
				payload: {},
				isError: false,
				message: '',
			});
			apiService.getCollectionInfoSolr(
				{
					params: {
						repository: acervo.code,
						isadg,
					},
				},
				{},
				(_, response) => {
					//console.log(response);
					if (+response?.father?.decendents === 0)
						navigate(`/glifos/item/${isadg}`, { replace: true });
					if (response?.father) {
						setIsadgMetadata({
							isLoading: false,
							payload: response,
							isError: false,
							message: '',
						});
					} else {
						setIsadgMetadata({
							isLoading: false,
							payload: {},
							isError: true,
							message: 'No se encontró la colección',
						});
					}
				}
			);
		} catch (e) {
			//console.log(e);
			setIsadgMetadata({
				isLoading: false,
				payload: {},
				isError: true,
				message: 'No se encontró la colección',
			});
		}
	}, [apiService, isadg, acervo, navigate]);

	if (IsadgMetadata.isError && !IsadgMetadata.isLoading)
		return (
			<ISADgCollectionError
				acervo={acervo}
				message={IsadgMetadata.message}
			/>
		);
	else if (
		!IsadgMetadata.isError &&
		!IsadgMetadata.isLoading &&
		IsadgMetadata?.payload?.father
	)
		return (
			<AboutLayout
				title={IsadgMetadata.payload.father.title}
				subtitle={acervo.title}
				isad={IsadgMetadata.payload}
				backgroundImage={acervo.agency}
				agency={acervo.agency}
				subtitleIcon={<House />}
				search
				apiService={apiService}
				setShowMetadata={setShowMetadata}
				showMetadata={showMetadata}
			>
				<ISADgCollectionContent
					isadg={isadg}
					acervo={acervo}
					apiService={apiService}
					hasHierarchyTree={
						+IsadgMetadata.payload?.father?.visibleDecendents > 0
					}
					mySelectedPhotos2={mySelectedPhotos2}
					showMetadata={showMetadata}
					itemInfo={itemInfo}
				/>
			</AboutLayout>
		);
	else return <ISADgCollectionLoading isadg={isadg} />;
}
